function getOneAppConfig(state) {
  return state.getIn(['config']);
}
function getDataControllerApiUrl(state) {
  return getOneAppConfig(state).get('dataControllerApiUrl');
}

const memberProducts = {
  fetch: (id, action, state) => ({
    url: `${getDataControllerApiUrl(state)}/servicing/v1/member`,
    opts: {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  }),
};

export const memberProductsV2 = {
  fetch: (id, action, state) => ({
    url: `${getDataControllerApiUrl(state)}/servicing/v2/member`,
    opts: {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  }),
};

export default memberProducts;
